import { HeadingProps } from "./types";

export function Heading({
  title,
  description,
  children,
  withBorder = true,
}: HeadingProps) {
  return (
    <div
      className={`flex flex-col justify-start items-start gap-2 py-4 ${withBorder ? "border-b border-border" : ""} lg:flex-row lg:items-center lg:justify-between`}
    >
      {(title || description) && (
        <div className="flex flex-col gap-1 mb-3 lg:mb-0">
          {title && (
            <h1 className="text-[28px] leading-9 font-bold text-foreground">
              {title}
            </h1>
          )}
          {description && (
            <p className="text-sm text-muted-foreground">{description}</p>
          )}
        </div>
      )}

      {children && <>{children}</>}
    </div>
  );
}
